import React, { Component } from 'react';
import {Button, Card, Col, Form, Icon, Input, Row, Switch, Cascader} from "antd";
import Table from './Table';
import { connect } from "react-redux";
import getDate from 'util/ConfigDates'
import{
  fetchOrders
} from "appRedux/actions/Orders";

class Orders extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dateFrom: getDate('dateFrom'),
      dateTo: getDate('dateTo'),

    }
  }



  componentDidMount() {
    this.props.fetchOrders(this.state  );
  }


  render ( ) {
    return (
        <Table/>
    );
  }
}

export default connect(null, { fetchOrders, })(Orders);



// WEBPACK FOOTER //
// ./src/routes/main/Orders/index.js